import { ISAPSettings } from 'features/settings/tenant-settings/sap';
import { BaseService } from 'shared/services/BaseService';

class SAPSettingsService extends BaseService<ISAPSettings> {
  constructor() {
    super('sap-settings');
  }
}

export const sapSettingsService = new SAPSettingsService();
